// client/src/components/admin/tools/ToolOutputDisplay.js
// Reusable component for displaying stdout/stderr output from admin tools
import PropTypes from 'prop-types'

/**
 * Component for displaying stdout and stderr output
 * @param {object} props - Component props
 * @param {string} props.stdout - Standard output text
 * @param {string} props.stderr - Standard error text
 */
function ToolOutputDisplay({ stdout, stderr }) {
  if (!stdout && !stderr) {
    return null
  }

  return (
    <>
      {stdout && (
        <div className="accordion-output">
          <pre
            className="mt-2 small bg-light p-2 border rounded"
            style={{ maxHeight: 120, overflow: 'auto' }}
          >
            {stdout}
          </pre>
        </div>
      )}
      {stderr && (
        <div className="accordion-output">
          <pre
            className="mt-2 small bg-warning p-2 border rounded"
            style={{ maxHeight: 120, overflow: 'auto' }}
          >
            {stderr}
          </pre>
        </div>
      )}
    </>
  )
}

ToolOutputDisplay.propTypes = {
  stdout: PropTypes.string,
  stderr: PropTypes.string,
}

export default ToolOutputDisplay
